import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import Select from '@helsenorge/designsystem-react/components/Select';
import { Breakpoint, useBreakpoint } from '@helsenorge/designsystem-react/hooks/useBreakpoint';
const DesktopSort = React.forwardRef((props, ref) => {
    const [maxLabelLength, setMaxLabelLength] = React.useState(10);
    const breakpoint = useBreakpoint();
    const isFluid = breakpoint === Breakpoint.xxs && props.fluidMobile;
    const handleSort = event => {
        props.onSort && props.onSort(event.target.value);
    };
    React.useEffect(() => {
        if (props.children.length > 0) {
            const newMaxLabelLength = Math.max(10, ...props.children.map(child => (child.label ? child.label.length : child.value?.length || 10)));
            setMaxLabelLength(newMaxLabelLength);
        }
    }, [props.children]);
    return (_jsx(Select, { label: props.label, width: isFluid ? undefined : maxLabelLength, disabled: props.disabled, onChange: handleSort, ref: ref, defaultValue: props.sortKey, wrapperClassName: props.selectClasses, children: props.children.map(child => (_jsx("option", { value: child.value, children: child.label || child.value }, child.key || child.label || child.value))) }));
});
DesktopSort.displayName = 'DesktopSort';
export default DesktopSort;
